import React from 'react'
import AHref from 'components/AHref';
import { EXTERNAL_URL } from 'utils/constants';
import './SsoPage.scss'

const SsoPage = ({
  children, title, description, footer, showTerms, gap
}) => {

  return (
    <div className='sso-page' style={{ gap }}>
      <div className='sso-page-header'>
        {title && <h1 className='sso-page-header__title viso-text-text vui-text-center'>{title}</h1>}
        {description && <p className='sso-page-header__description viso-text-label vui-text-center'>{description}</p>}
      </div>
      <div className='sso-page__content'>{children}</div>
      <div className='sso-page__footer viso-text-label'>
        {footer}
        {showTerms && <>
          <div>
            By continuing, you agree to the <AHref href={EXTERNAL_URL.terms} className="text-link text-decoration-undeline" rel="noreferrer" target="_blank">Terms of Service</AHref>
          </div>
          <div>
            and <AHref href={EXTERNAL_URL.policy} className="text-link text-decoration-undeline" rel="noreferrer" target="_blank">Privacy policy</AHref>.
          </div>
        </>
        }
      </div>
    </div>
  )
}

export default SsoPage